import s from 'components/BackgroundImageMonthReport/BackgroundImageMonthReportBotPosition.module.css';

const BackgroundImageMonthReportBotPosition = () => {
  return <div className={s.backgroundImageBot} />;
};

export default BackgroundImageMonthReportBotPosition;
